export default {
  ToolingLocationsSearch: {
    tooManyResults: hits =>
      `There are ${hits} search results. That is too many. Please narrow your query`,
    noResults: hits =>
      `There are ${hits} search results. Please broaden your query`,
  },
  BidMatchSettings: {
    addError:
      'An error occurred when trying to create a new Notification card.',
    deleteError:
      'An error occurred when trying to delete your Notification card',
    editError: 'An error occurred when trying to edit your Notification card',
  },
  filterGroupUtils: {
    missingGroupKey: 'Missing groupKey prop',
    missingFilter: 'Missing filter prop with targeted proeprty',
  },
  ProcurementHistorySearch: {
    tooManyResults: hits =>
      `There are ${hits} search results. That is too many. Please narrow your query`,
    noResults: hits =>
      `There are ${hits} search results. Please broaden your query`,
  },
};



// WEBPACK FOOTER //
// ./src/config/errors.js